<template>
  <div class="m-b-md">
    <h4>{{ title }}</h4>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>{{ column }}</th>
        <th class="actions-column">Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, index) in rows" :key="index">
        <td>
          <select2
            v-model="row.value"
            :options="select2OptionsFor(row)"
            :placeholder="'-- ' + column + ' auswählen --'"
            :settings="{width: '100%'}"
            @change="emitValues"
          ></select2>
        </td>
        <td class="text-center">
          <button class="btn btn-outline btn-danger" type="button" @click="removeRow(index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-block btn-outline btn-info btn-sm" type="button" @click="addRow">
      <i class="fa fa-plus"></i> Hinzufügen
    </button>
    <input v-for="selected in value" :key="selected" :name="name + '[]'" :value="selected" type="hidden"/>
  </div>
</template>

<script>
export default {
  name: "LoyaltyPromotionRestrictionTable",
  props: {
    title: {
      type: String,
      required: true
    },
    column: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rows: []
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(values) {
        if (this.rowsMatch(values)) {
          return;
        }
        this.rows = values.map(value => ({value}));
      }
    }
  },
  methods: {
    rowsMatch(values) {
      const current = this.selectedValues();
      return current.length === values.length && current.every((value, index) => value === values[index]);
    },
    selectedValues() {
      return this.rows.map(row => row.value).filter(value => value !== "");
    },
    // Hide values chosen in other rows; keep the row's own value even if it no longer occurs in the transactions.
    optionsFor(row) {
      const takenByOtherRows = this.rows.filter(other => other !== row).map(other => other.value);
      const available = this.options.filter(option => !takenByOtherRows.includes(option));

      if (row.value === "" || available.includes(row.value)) {
        return available;
      }
      return [row.value, ...available];
    },
    // Leading empty entry is required for the select2 placeholder.
    select2OptionsFor(row) {
      return [{id: "", text: ""}, ...this.optionsFor(row).map(option => ({id: option, text: option}))];
    },
    addRow() {
      this.rows.push({value: ""});
    },
    removeRow(index) {
      this.rows.splice(index, 1);
      this.emitValues();
    },
    emitValues() {
      this.$emit("input", [...new Set(this.selectedValues())]);
    }
  }
};
</script>

<style scoped>
.table {
  margin-top: 10px;
}

.actions-column {
  width: 100px;
}
</style>
